<div class="animated fadeIn container-fluid">
  @if (statusWorkflow.recoveryError) { <div class="alert alert-warning" role="alert">{{ statusWorkflow.recoveryError }}</div> }
  @for (operation of pendingStatusOperations; track operation.memberId) {
    <div class="alert alert-warning status-recovery" role="alert">
      <p class="mb-2">会員ID {{ operation.memberId }}: {{ operation.message }}</p>
      <button class="btn btn-outline-primary btn-sm" type="button" [disabled]="statusBusy(operation)" (click)="refreshMemberStatus(operation)">一覧を再取得</button>
      @if (operation.phase === 'unknown' || operation.phase === 'partial') {
        <label class="d-block mt-2"><input type="checkbox" [(ngModel)]="statusOutcomeChecked[operation.memberId]"> 会員状態・履歴・鍵の実際の結果を確認しました</label>
        <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="!statusOutcomeChecked[operation.memberId]" (click)="acknowledgeMemberStatus(operation)">確認済みにする</button>
      }
    </div>
  }

  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12"><div style="height: 1px"></div></div>
      </div>
      @if (unprocessedExists) {
        <div class="alert alert-danger" role="alert">
          <button type="button" class="close" aria-label="Close" (click)="unprocessedExists = false">
            <span aria-hidden="true">&times;</span>
          </button>
          <span>処理されていない諸届があります。諸届申請をご確認ください。</span>
        </div>
      }
      <!-- 旧版 member.html:16-18 の <flash-message> 相当（未処理諸届の注意文の後） -->
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label" for="studio_name">店舗</label>
                <select class="form-control" id="studio_name" name="studio_name"
                  [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (studio of studios; track studio.id) {
                    <option [ngValue]="studio">{{ studio.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>

          @if (showFilterOption) {
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="studio_plan">区分コース</label>
                  <select class="form-control" id="studio_plan" [(ngModel)]="studioPlanFilter" name="studio_plan">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (plan of studioPlans; track plan.id) {
                      <option [ngValue]="plan">{{ plan.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="pay_method">支払方法</label>
                  <select class="form-control" id="pay_method" [(ngModel)]="paymentMethodFilter" name="pay_method">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (opt of paymentMethodOption; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }
        </div>

        @if (showFilterOption) {
          <div class="row">
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="status">在籍状況</label>
                  <select class="form-control" id="status" [(ngModel)]="statusFilter" name="status">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (opt of statusOption; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="datePickerFrom">仮登録日</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <input id="datePickerFrom" name="date_from" type="date" [(ngModel)]="dateFrom" class="form-control">
                    </div>
                    <div><span>&nbsp;~&nbsp;</span></div>
                    <div class="bisected-input">
                      <input id="datePickerTo" name="date_to" type="date" [(ngModel)]="dateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="datePickerFrom3">本登録日</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <input id="datePickerFrom3" name="enable_date_from" type="date" [(ngModel)]="enableDateFrom" class="form-control">
                    </div>
                    <div><span>&nbsp;~&nbsp;</span></div>
                    <div class="bisected-input">
                      <input id="datePickerTo3" name="enable_date_to" type="date" [(ngModel)]="enableDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="pay_status">支払方法の有効性</label>
                  <select class="form-control" id="pay_status" [(ngModel)]="paymentStatusFilter" name="pay_status">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (opt of paymentStatusOption; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="align-items: flex-end;">
            <div class="col-md-8">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword"
                    (ngModelChange)="onKeywordChange()" class="form-control"
                    placeholder="会員ID、会員氏名、メールアドレス、入退館キーIDなど">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                    <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </form>
      <hr>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-12">
          <!-- MM-13: 新規作成 — opens member app in new window (was routerLink to undefined route) -->
          @if (selectedStudio && selectedStudio.status === 0) {
            <button class="form-group btn btn-primary text-white" type="button" (click)="openNewMember()">
              <i class="fa s-icon-plus"></i>&nbsp;新規作成
            </button>
          }
          @if (userPermission <= 1) {
            <!-- MM-14: データ作成(全店一括) — opens confirmation modal -->
            <button class="form-group btn btn-success" type="button" (click)="showDownloadAllModal = true">
              <div class="file_format_icon dl">
                <div>
                  <span title="csv"></span>
                  <span class="material-symbols-outlined align-bottom">add_notes</span>
                </div>
              </div>
              &nbsp;データ作成(全店一括)
            </button>
          }
          @if (userPermission <= 1 && showFilterOption) {
            <!-- MM-15: データ作成 — opens confirmation modal -->
            <button class="form-group btn btn-success" type="button" (click)="showDownloadModal = true">
              <div class="file_format_icon dl">
                <div>
                  <span title="csv"></span>
                  <span class="material-symbols-outlined align-bottom">add_notes</span>
                </div>
              </div>
              &nbsp;データ作成
            </button>
          }
          @if (showFilterOption) {
            <!-- MM-16: 来館アンケート — opens member app visitors flow -->
            <button class="form-group btn btn-primary text-white" type="button" (click)="openVisitors()">
              <i class="fa s-icon-survey" aria-hidden="true"></i>&nbsp;来館アンケート
            </button>
          }
          @if (userPermission <= 10 || insuranceProduct) {
            <a class="form-group btn btn-primary text-white" routerLink="/insurance">
              <span class="material-icons-outlined" style="font-size: inherit;">volunteer_activism</span>&nbsp;保険適応
            </a>
          }
        </div>
      </div>

      <!-- Pagination top -->
      <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>

      @if (selectedStudio && !searching && filteredItems.length === 0) {
        <span>該当するデータはありません</span>
      }

      @if (searching) {
        <div class="text-center py-3">
          <span class="fa fa-spinner fa-spin fa-2x"></span>
        </div>
      }

      @if (filteredItems.length > 0) {
        <table class="table table-bordered table-sm table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">状態/備考</th>
              <th width="10%">会員ID</th>
              <th width="12%">会員氏名(かな)</th>
              <th width="12%">区分コース</th>
              <th width="7%">入退館キー</th>
              <th width="7%">ロッカー</th>
              <th width="13%">仮登録日時</th>
              <th width="13%">本登録日時</th>
              <th width="16%"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td class="text-center">
                  <div [class]="(item.note || item.status === 5 || item.status === 6) ? 'd-flex flex-column align-items-center' : ''">
                    @if (item.note && item.isExpulsionAlert === 1) {
                      <button class="btn p-0 bg-inherit text-danger active" type="button" title="備考"
                        (click)="openNoteModal(item)">
                        <i class="fa fa-exclamation-triangle icon-info-size"></i>
                      </button>
                    }
                    @if (item.note && item.isExpulsionAlert === 0) {
                      <button class="btn p-0 bg-inherit text-primary active" type="button" title="備考"
                        (click)="openNoteModal(item)">
                        <i class="fa s-icon-information icon-info-size"></i>
                      </button>
                    }
                    @if (item.status === 5 || item.status === 6) {
                      <button class="btn p-0 bg-inherit text-primary active" type="button" title="仮登録へ"
                        (click)="register(item)">
                        <i class="fa fa-user-plus icon-info-size"></i>
                      </button>
                    }
                    @if (item.status === 0) {
                      <button class="btn text-green p-0 bg-inherit active" type="button" title="在籍中">
                        <i class="fa fa-3x fa-toggle-on"></i>
                      </button>
                    }
                    @if (item.status === 1) {
                      <button class="btn text-secondary bg-inherit p-0 active" type="button" title="停止"
                        (click)="openMemberStatusModal(item.id, item.status, false, $event)">
                        <i class="fa fa-3x fa-toggle-off"></i>
                      </button>
                    }
                    @if (item.status === 2) {
                      <button class="btn text-red p-0 bg-inherit active" type="button" title="停止(除名)"
                        (click)="openMemberStatusModal(item.id, item.status, false, $event)">
                        <i class="fa fa-3x fa-toggle-off"></i>
                      </button>
                    }
                    @if (item.status === 4 || item.status === 5 || item.status === 6) {
                      <button class="btn text-warning p-0 bg-inherit active" type="button" title="仮登録">
                        <i class="fa fa-3x fa-toggle-on"></i>
                      </button>
                    }
                  </div>
                </td>
                <td>{{ item.memberCode }}</td>
                <!-- MM-11: 会員氏名(かな) — clickable link opening member detail modal -->
                <td>
                  <a href="" class="text-primary" (click)="setSelectMember(item); $event.preventDefault()">
                    {{ item.lastName }}&nbsp;{{ item.firstName }}&#040;{{ item.lastNameKana }}&nbsp;{{ item.firstNameKana }}&#041;
                  </a>
                </td>
                <td>
                  @if (item.studioPlanId === 999999999) {
                    見学予約
                  } @else {
                    {{ item.studioPlan?.name }}
                  }
                </td>
                <td class="text-right">{{ item.keyNumber?.keyNumber }}</td>
                <td class="text-right">{{ item.lockerNumber?.lockerNumber }}</td>
                <td class="text-right">{{ item.createdAt | date:'yyyy/MM/dd HH:mm' }}</td>
                <td class="text-right">
                  @if (!item.desiredStartDate || item.enabledAt) {
                    {{ item.enabledAt | date:'yyyy/MM/dd HH:mm' }}
                  } @else {
                    <span>{{ item.desiredStartDate | date:'yyyy/MM/dd' }}</span>
                    <button class="mt-1 mb-1 btn btn-outline-danger btn-sm"
                      type="button" title="利用開始日キャンセル"
                      (click)="openClearStartDateModal(item.id)"
                      style="padding-left: 0.2rem; padding-right: 0.2rem">
                      <i class="fa fa-times fa-fw"></i>
                    </button>
                  }
                </td>
                <td>
                  <div>
                    @if (item.status !== 6) {
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        [routerLink]="['/member', item.id, 'edit']" title="編集">
                        <i class="fa s-icon-edit fa-fw"></i>
                      </a>
                    }
                    <!-- MM-12: 支払方法の確認 — click handler added -->
                    @if (item.status === 0 || item.status === 4) {
                      <button type="button" class="mt-1 mb-1 btn btn-primary btn-sm text-white" title="支払方法の確認"
                        (click)="getPayment(item.id)">
                        <i class="fa s-icon-method fa-fw"></i>
                      </button>
                    }
                    @if (item.status === 0) {
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        [routerLink]="['/notification', item.id]" title="諸届申請一覧">
                        <i class="fa fa-inbox fa-fw"></i>
                      </a>
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white" [routerLink]="['/subscription', item.id]" title="物販定期便">
                        <span class="material-symbols-outlined fa-fw" style="font-size: 14px; vertical-align: middle;">hand_package</span>
                      </a>
                    }
                    @if (item.status === 2) {
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        [routerLink]="['/notification', item.id, 'expel']" title="除名解除">
                        <i class="fa fa-leaf fa-fw"></i>
                      </a>
                    }
                    @if (item.status === 0) {
                      <button class="mt-1 mb-1 btn btn-warning btn-sm text-white" type="button"
                              (click)="openCreateTransaction(item)" title="売上">
                        <i class="fa s-icon-settlement fa-fw"></i>
                      </button>
                    }
                    @if (item.status !== 4 && item.status !== 5 && item.status !== 6) {
                      <a class="mt-1 mb-1 btn btn-warning btn-sm text-white"
                        [routerLink]="['/transaction', item.id, 'all']" title="売上一覧">
                        <i class="fa s-icon-salesList fa-fw"></i>
                      </a>
                    }
                    @if (selectedStudio?.isCounselable === 1) {
                      <a class="mt-1 mb-1 btn btn-success btn-sm text-white"
                        [routerLink]="['/counsel', item.id]" title="カウンセリング">
                        <i class="fa s-icon-member fa-fw"></i>
                      </a>
                    }
                    @if (item.status === 1 && userPermission <= 10) {
                      <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" title="削除"
                        (click)="openMemberStatusModal(item.id, item.status, true, $event)">
                        <i class="fa s-icon-delete fa-fw"></i>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      <!-- Pagination bottom -->
      <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>

    </div>
  </div>

</div>

<!-- MM-11: 会員情報 詳細モーダル -->
@if (showMemberDetailModal && selectedMember) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">会員情報 / 詳細</h5>
          <button type="button" class="close" (click)="showMemberDetailModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table class="table table-sm table-borderless">
              <tr>
                <th class="text-right" style="width: 40%;">会員ID：</th>
                <td>{{ selectedMember.memberCode }}</td>
              </tr>
              <tr>
                <th class="text-right">会員氏名（かな）：</th>
                <td>{{ selectedMember.lastName }} {{ selectedMember.firstName }}({{ selectedMember.lastNameKana }} {{ selectedMember.firstNameKana }})</td>
              </tr>
              <tr>
                <th class="text-right">生年月日：</th>
                <td>{{ selectedMember.birthday }}</td>
              </tr>
              <tr>
                <th class="text-right">住所：</th>
                <td>〒{{ selectedMember.zip }}</td>
              </tr>
              <tr>
                <th class="text-right"></th>
                <td>{{ selectedMember.province }}&nbsp;{{ selectedMember.city }}</td>
              </tr>
              <tr>
                <th class="text-right"></th>
                <td>{{ selectedMember.area }}&nbsp;{{ selectedMember.address }}</td>
              </tr>
              <tr>
                <th class="text-right">電話番号：</th>
                <td>{{ selectedMember.phone }}</td>
              </tr>
              <tr>
                <th class="text-right">メールアドレス：</th>
                <td>{{ selectedMember.email }}</td>
              </tr>
              <tr>
                <th class="text-right">コース区分：</th>
                <td>{{ selectedMember.studioPlan?.name }}</td>
              </tr>
              <tr>
                <th class="text-right">支払方法：</th>
                <td>
                  @if (selectedMember.payment?.paymentMethod == 0) { <span>口座振替</span> }
                  @if (selectedMember.payment?.paymentMethod == 1) { <span>クレジット</span> }
                </td>
              </tr>
              <tr>
                <th class="text-right">入退館キー：</th>
                <td>{{ selectedMember.keyNumber?.keyNumber }}</td>
              </tr>
              <tr>
                <th class="text-right">ロッカー：</th>
                <td>{{ selectedMember.lockerNumber?.lockerNumber }}</td>
              </tr>
              <tr>
                <th class="text-right">登録日時：</th>
                <td>{{ selectedMember.createdAt | date:'yyyy/MM/dd HH:mm' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showMemberDetailModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Member status workflow form -->
@if (activeStatusTarget; as target) {
  <app-member-status-dialog [target]="target" [operation]="statusWorkflow.operation(target.studioId, target.memberId)"
    [returnFocus]="statusTrigger" (submitted)="applyMemberStatus($event)" (closed)="closeMemberStatusModal()"></app-member-status-dialog>
}

<!-- Clear start date modal -->
@if (showClearStartDateModal) {
  <div class="modal-backdrop fade show" (click)="closeClearStartDateModal()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">利用開始日キャンセル</h5>
          <button type="button" class="close" (click)="closeClearStartDateModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">利用開始日をキャンセルします。</label>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="closeClearStartDateModal()">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button type="button" class="btn btn-danger" (click)="clearStartDate()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Member note modal -->
@if (showNoteModal) {
  <div class="modal-backdrop fade show" (click)="closeNoteModal()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">備考</h5>
          <button type="button" class="close" (click)="closeNoteModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-0" style="white-space: pre-wrap;">{{ selectedMemberNote }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="closeNoteModal()">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Member alert note modal -->
@if (showAlertNoteModal) {
  <div class="modal-backdrop fade show" (click)="closeNoteModal()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <!-- 旧版 member.html:560-580 showAlertNoteModal の配色・ボタンに合わせる -->
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title">備考</h5>
          <button type="button" class="close text-white" (click)="closeNoteModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background: #FFF6F8;">
          <p class="mb-0" style="white-space: pre-wrap;">{{ selectedMemberNote }}</p>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8;">
          <button class="btn bg-close text-white" type="button" (click)="closeNoteModal()">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-primary text-white" type="button" (click)="solveNote()">
            <i class="fa s-icon-turnOver"></i>&nbsp;解決
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- MM-12: 支払方法の確認モーダル -->
@if (showPaymentModal && selectedPayment) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">支払方法の確認</h5>
          <button type="button" class="close" (click)="showPaymentModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table class="table table-sm table-borderless">
              <tr>
                <th class="text-right">支払方法:</th>
                <td>
                  @if (selectedPayment.paymentMethod == '0') { <span>口座振替</span> }
                  @if (selectedPayment.paymentMethod == '1') { <span>クレジットカード</span> }
                </td>
              </tr>
              @if (selectedPayment.paymentMethod == '0') {
                <tr>
                  <th class="text-right">銀行コード:</th>
                  <td>{{ selectedPayment.btBankCode }}</td>
                </tr>
                <tr>
                  <th class="text-right">支店コード:</th>
                  <td>{{ selectedPayment.btBranchCode }}</td>
                </tr>
                <tr>
                  <th class="text-right">口座番号:</th>
                  <td>{{ selectedPayment.btAccountType == 1 ? '普通' : (selectedPayment.btAccountType == 2 ? '当座' : '') }} {{ selectedPayment.btCardNum }}</td>
                </tr>
                <tr>
                  <th class="text-right">名義:</th>
                  <td>{{ selectedPayment.btAccountName }}</td>
                </tr>
              }
              @if (selectedPayment.paymentMethod == '1') {
                <tr>
                  <th class="text-right">クレジットカード番号:</th>
                  <td>{{ selectedGmo?.CardNo }}</td>
                </tr>
                <tr>
                  <th class="text-right">クレジットカード名義:</th>
                  <td>{{ selectedGmo?.HolderName }}</td>
                </tr>
                <tr>
                  <th class="text-right">クレジットカード有効期限:</th>
                  <td>{{ selectedGmo?.expireMonthAt }}月 {{ selectedGmo?.expireYearAt }}年</td>
                </tr>
                <tr>
                  <th class="text-right">セキュリティコード:</th>
                  <td>{{ selectedGmo?.security }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showPaymentModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="notificationPayment()">
            <i class="fa fa-inbox fa-fw"></i><span>&nbsp;支払方法諸届申請</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- MM-14: データ作成(全店一括) 確認モーダル -->
@if (showDownloadAllModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">会員ダウンロードデータ作成(全店)</h5>
          <button type="button" class="close" (click)="showDownloadAllModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          在籍ステータスに関わらず、データベースに保存されている、全店舗のすべての会員データを作成します。作成されたデータには会員の個人情報が含まれます。<br /><br />
          作成後、ダウンロード管理画面からダウンロードが可能です。<br />
          作成しますか？
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadAllModal = false">
            <span class="material-symbols-outlined align-bottom">cancel</span>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="downloadCsvAll()">
            <span class="material-symbols-outlined align-bottom">add_notes</span>&nbsp;はい
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- MM-17: 売上新規作成モーダル -->
@if (showTransactionModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">新規作成@if (!inTheInput) {<span> 確認</span>}</h5>
          <button type="button" class="close" (click)="showTransactionModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #tranForm="ngForm">
          <div class="modal-body">
            <div class="row">
              <!-- 旧版 member.html createTransactionModal の modal-body 先頭 <flash-message> 相当 -->
              @if (transactionMessage) {
                <div class="col-md-12">
                  <div class="alert alert-success alert-dismissible" role="alert">
                    {{ transactionMessage }}
                    <button type="button" class="close" aria-label="通知を閉じる" (click)="clearTransactionMessage()"><span aria-hidden="true">&times;</span></button>
                  </div>
                </div>
              }
              <div class="col-md-12">
                @if (inTheInput) {
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">店舗</label>
                    <label class="col-md-8 col-form-label">{{ memberForTransaction?.studio?.name }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">売上年月</label>
                    <label class="col-md-8 col-form-label">{{ transaction.yearPay }}年{{ transaction.monthPay }}月</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">会員ID・会員氏名</label>
                    <label class="col-md-8 col-form-label">
                      {{ memberForTransaction?.memberCode }}&nbsp;&nbsp;{{ memberForTransaction?.lastName }}&nbsp;{{ memberForTransaction?.firstName }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">支払方法</label>
                    <label class="col-md-8 col-form-label">
                      @if (memberForTransaction?.payment?.paymentMethod == 0) { <span>口座振替</span> }
                      @if (memberForTransaction?.payment?.paymentMethod == 1) { <span>クレジット</span> }
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">売上タイプ</label>
                    <div class="col-md-8">
                      <select class="form-control" name="chargeType" [(ngModel)]="transaction.chargeType"
                              (ngModelChange)="onTransactionChargeTypeChange()" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (ct of chargeTypeOption; track ct.id) {
                          <option [ngValue]="ct.id">{{ ct.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">商品</label>
                    <div class="col-md-8">
                      <select class="form-control" name="product" [(ngModel)]="transaction.product" required>
                        <option [ngValue]="null">-- 選択してください --</option>
                        @for (p of filteredTransactionProducts; track p.id) {
                          <option [ngValue]="p">(¥{{ productPriceWithTax(p) | number:'1.0-0' }}) {{ p.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">調整額</label>
                    <div class="col-md-8">
                      <input type="number" class="form-control" name="adjustment"
                             [(ngModel)]="transaction.adjustment" placeholder="調整範囲: ±99999"
                             [min]="transaction.product ? -productPriceWithTax(transaction.product) : 0"
                             max="99999" step="1">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8 col-form-label">
                      @if (transaction.product) { <span>¥{{ transactionTotal | number:'1.0-0' }}</span> }
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">明細</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" name="title"
                             [(ngModel)]="transaction.title" required>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">備考</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" name="note"
                             [(ngModel)]="transaction.note" sfMaxLength="200">
                    </div>
                  </div>
                }
                @if (!inTheInput) {
                  <div class="form-group row">
                    <label class="col-md-12 col-form-label">下記の内容で売上を登録します。よろしいですか。</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">店舗</label>
                    <label class="col-md-8 col-form-label">{{ memberForTransaction?.studio?.name }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">売上年月</label>
                    <label class="col-md-8 col-form-label">{{ transaction.yearPay }}年{{ transaction.monthPay }}月</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">会員ID</label>
                    <label class="col-md-8 col-form-label">{{ memberForTransaction?.memberCode }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">会員氏名</label>
                    <label class="col-md-8 col-form-label">{{ memberForTransaction?.lastName }}&nbsp;{{ memberForTransaction?.firstName }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">支払方法</label>
                    <label class="col-md-8 col-form-label">
                      @if (memberForTransaction?.payment?.paymentMethod == 0) { <span>口座振替</span> }
                      @if (memberForTransaction?.payment?.paymentMethod == 1) { <span>クレジット</span> }
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">売上タイプ</label>
                    <label class="col-md-8 col-form-label">{{ chargeTypeName(transaction.chargeType) }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">商品</label>
                    <div class="col-md-8">
                      @if (transaction.product) {
                        <span>(¥{{ productPriceWithTax(transaction.product) | number:'1.0-0' }}) {{ transaction.product.name }}</span>
                      }
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">調整額</label>
                    <div class="col-md-8">
                      @if (transaction.adjustment != null && transaction.adjustment !== '') {
                        <span>¥{{ transaction.adjustment | number:'1.0-0' }}</span>
                      }
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8 col-form-label">
                      <span>¥{{ transactionTotal | number:'1.0-0' }}</span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">明細</label>
                    <div class="col-md-8">
                      <span>{{ transaction.title }}</span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">備考</label>
                    <div class="col-md-8">
                      <span>{{ transaction.note }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="modal-footer">
            @if (inTheInput) {
              <button class="btn bg-close text-white" type="button" (click)="showTransactionModal = false">
                <i class="fa s-icon-cancel"></i>&nbsp;閉じる
              </button>
              <button class="btn btn-success" type="button" (click)="toggleInTheInput()"
                      [disabled]="tranForm.invalid || !isTransactionValid">
                <i class="fa s-icon-save"></i>&nbsp;確認
              </button>
            }
            @if (!inTheInput) {
              <button class="btn bg-close text-white" type="button" (click)="toggleInTheInput()">
                <i class="fa s-icon-cancel"></i>&nbsp;戻る
              </button>
              <button class="btn btn-success" type="button" (click)="saveTransaction()" [disabled]="!isTransactionValid">
                <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
}

<!-- MM-15: データ作成 確認モーダル -->
@if (showDownloadModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">会員ダウンロードデータ作成</h5>
          <button type="button" class="close" (click)="showDownloadModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          在籍ステータスに関わらず、データベースに保存されている、該当店舗のすべての会員データを作成します。作成されたデータには会員の個人情報が含まれます。<br /><br />
          作成後、ダウンロード管理画面からダウンロードが可能です。<br />
          作成しますか？
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadModal = false">
            <span class="material-symbols-outlined align-bottom">cancel</span>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="downloadCsv()">
            <span class="material-symbols-outlined align-bottom">add_notes</span>&nbsp;はい
          </button>
        </div>
      </div>
    </div>
  </div>
}
